import { Grid, Typography } from '@mui/material'
import { LabelPosition, RHookFormTextFieldWithLabel } from '@websential/cosmic'

import React from 'react'

export interface IT3SummaryAxisPages1 { }
const T3SummaryAxisPages1: React.FC<IT3SummaryAxisPages1> = () => {
    return (
        <Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} spacing={2}>
            <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                <Typography sx={{ color: "rgba(0, 0, 0, 0.6)", fontWeight: "bold", padding: "0 0 1rem 100px", textAlign: "center", fontSize: "1.2rem" }}>
                    X-Axis
                </Typography>
                <RHookFormTextFieldWithLabel
                    id={'accountNumberP1X'}
                    testId={'accountNumberP1X'}
                    label={'Account Number'}
                    labelPosition={LabelPosition.Left}
                    defaultValue={40}
                />
                <RHookFormTextFieldWithLabel
                    id={'nameOfTrustX'}
                    testId={'nameOfTrustX'}
                    label={'Name of Trust'}
                    labelPosition={LabelPosition.Left}
                    defaultValue={40}
                />
                <RHookFormTextFieldWithLabel
                    id={'box10X'}
                    testId={'box10X'}
                    label={'Box 10'}
                    labelPosition={LabelPosition.Left}
                    defaultValue={250}
                />
                <RHookFormTextFieldWithLabel
                    id={'box21X'}
                    testId={'box21X'}
                    label={'Box 21'}
                    labelPosition={LabelPosition.Left}
                    defaultValue={475}
                />
                <RHookFormTextFieldWithLabel
                    id={'box23X'}
                    testId={'box23X'}
                    label={'Box 23'}
                    labelPosition={LabelPosition.Left}
                    defaultValue={250}
                />
                <RHookFormTextFieldWithLabel
                    id={'box30X'}
                    testId={'box30X'}
                    label={'Box 30'}
                    labelPosition={LabelPosition.Left}
                    defaultValue={475}
                />
                <RHookFormTextFieldWithLabel
                    id={'box32X'}
                    testId={'box32X'}
                    label={'Box 32'}
                    labelPosition={LabelPosition.Left}
                    defaultValue={250}
                />
                <RHookFormTextFieldWithLabel
                    id={'box49X'}
                    testId={'box49X'}
                    label={'Box 49'}
                    labelPosition={LabelPosition.Left}
                    defaultValue={475}
                />
                <RHookFormTextFieldWithLabel
                    id={'box11X'}
                    testId={'box11X'}
                    label={'Box 11'}
                    labelPosition={LabelPosition.Left}
                    defaultValue={320}
                />
                <RHookFormTextFieldWithLabel
                    id={'box39X'}
                    testId={'box39X'}
                    label={'Box 39'}
                    labelPosition={LabelPosition.Left}
                    defaultValue={250}
                />
                <RHookFormTextFieldWithLabel
                    id={'box50X'}
                    testId={'box50X'}
                    label={'Box 50'}
                    labelPosition={LabelPosition.Left}
                    defaultValue={475}
                />
                <RHookFormTextFieldWithLabel
                    id={'box26X'}
                    testId={'box26X'}
                    label={'Box 26'}
                    labelPosition={LabelPosition.Left}
                    defaultValue={250}
                />
                <RHookFormTextFieldWithLabel
                    id={'box51X'}
                    testId={'box51X'}
                    label={'Box 51'}
                    labelPosition={LabelPosition.Left}
                    defaultValue={475}
                />
                <RHookFormTextFieldWithLabel
                    id={'trusteNameX'}
                    testId={'trusteNameX'}
                    label={'Truste Name'}
                    labelPosition={LabelPosition.Left}
                    defaultValue={300}
                />
                <RHookFormTextFieldWithLabel
                    id={'trusteAddressX'}
                    testId={'trusteAddressX'}
                    label={'Truste Address'}
                    labelPosition={LabelPosition.Left}
                    defaultValue={300}
                />
                <RHookFormTextFieldWithLabel
                    id={'telephoneP1X'}
                    testId={'telephoneP1X'}
                    label={'Telephone'}
                    labelPosition={LabelPosition.Left}
                    defaultValue={170}
                />
                <RHookFormTextFieldWithLabel
                    id={'contactPersonNameX'}
                    testId={'contactPersonNameX'}
                    label={'Contact Person Name'}
                    labelPosition={LabelPosition.Left}
                    defaultValue={300}
                />
                <RHookFormTextFieldWithLabel
                    id={'contractPersonAddressLineX'}
                    testId={'contractPersonAddressLineX'}
                    label={'Contract Person Address Line'}
                    labelPosition={LabelPosition.Left}
                    defaultValue={300}
                />
                
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                <Typography sx={{ color: "rgba(0, 0, 0, 0.6)", fontWeight: "bold", padding: "0 0 1rem 100px", textAlign: "center", fontSize: "1.2rem" }}>
                    Y-Axis
                </Typography>
                <RHookFormTextFieldWithLabel
                    id={'accountNumberP1Y'}
                    testId={'accountNumberP1Y'}
                    label={'Account Number'}
                    labelPosition={LabelPosition.Left}
                    defaultValue={520}
                />
                <RHookFormTextFieldWithLabel
                    id={'nameOfTrustY'}
                    testId={'nameOfTrustY'}
                    label={'Name of Trust'}
                    labelPosition={LabelPosition.Left}
                    defaultValue={540}
                />
                <RHookFormTextFieldWithLabel
                    id={'box10Y'}
                    testId={'box10Y'}
                    label={'Box 10'}
                    labelPosition={LabelPosition.Left}
                    defaultValue={335}
                />
                <RHookFormTextFieldWithLabel
                    id={'box21Y'}
                    testId={'box21Y'}
                    label={'Box 21'}
                    labelPosition={LabelPosition.Left}
                    defaultValue={335}
                />
                <RHookFormTextFieldWithLabel
                    id={'box23Y'}
                    testId={'box23Y'}
                    label={'Box 23'}
                    labelPosition={LabelPosition.Left}
                    defaultValue={289}
                />
                <RHookFormTextFieldWithLabel
                    id={'box30Y'}
                    testId={'box30Y'}
                    label={'Box 30'}
                    labelPosition={LabelPosition.Left}
                    defaultValue={289}
                />
                <RHookFormTextFieldWithLabel
                    id={'box32Y'}
                    testId={'box32Y'}
                    label={'Box 32'}
                    labelPosition={LabelPosition.Left}
                    defaultValue={245}
                />
                <RHookFormTextFieldWithLabel
                    id={'box49Y'}
                    testId={'box49Y'}
                    label={'Box 49'}
                    labelPosition={LabelPosition.Left}
                    defaultValue={245}
                />
                <RHookFormTextFieldWithLabel
                    id={'box11Y'}
                    testId={'box11Y'}
                    label={'Box 11'}
                    labelPosition={LabelPosition.Left}
                    defaultValue={205}
                />
                <RHookFormTextFieldWithLabel
                    id={'box39Y'}
                    testId={'box39Y'}
                    label={'Box 39'}
                    labelPosition={LabelPosition.Left}
                    defaultValue={205}
                />
                <RHookFormTextFieldWithLabel
                    id={'box50Y'}
                    testId={'box50Y'}
                    label={'Box 50'}
                    labelPosition={LabelPosition.Left}
                    defaultValue={167}
                />
                <RHookFormTextFieldWithLabel
                    id={'box26Y'}
                    testId={'box26Y'}
                    label={'Box 26'}
                    labelPosition={LabelPosition.Left}
                    defaultValue={167}
                />
                <RHookFormTextFieldWithLabel
                    id={'box51Y'}
                    testId={'box51Y'}
                    label={'Box 51'}
                    labelPosition={LabelPosition.Left}
                    defaultValue={167}
                />
                <RHookFormTextFieldWithLabel
                    id={'trusteNameY'}
                    testId={'trusteNameY'}
                    label={'Truste Name'}
                    labelPosition={LabelPosition.Left}
                    defaultValue={535}
                />
                <RHookFormTextFieldWithLabel
                    id={'trusteAddressY'}
                    testId={'trusteAddressY'}
                    label={'Truste Address'}
                    labelPosition={LabelPosition.Left}
                    defaultValue={520}
                />
                <RHookFormTextFieldWithLabel
                    id={'telephoneP1Y'}
                    testId={'telephoneP1Y'}
                    label={'Telephone'}
                    labelPosition={LabelPosition.Left}
                    defaultValue={520}
                />
                <RHookFormTextFieldWithLabel
                    id={'contactPersonNameY'}
                    testId={'contactPersonNameY'}
                    label={'Contact Person Name'}
                    labelPosition={LabelPosition.Left}
                    defaultValue={490}
                />
                <RHookFormTextFieldWithLabel
                    id={'contractPersonAddressLineY'}
                    testId={'contractPersonAddressLineY'}
                    label={'Contract Person Address Line'}
                    labelPosition={LabelPosition.Left}
                    defaultValue={480}
                />
            </Grid>
        </Grid>
    )
}

export default T3SummaryAxisPages1